var map = {
	"./abacus_type_1 (old).png": "40d1",
	"./abacus_type_1.png": "59f2",
	"./abacus_type_2 (old).png": "a66d",
	"./abacus_type_2.png": "5c84",
	"./abacus_type_3 (old).png": "56f0",
	"./abacus_type_3.png": "079d",
	"./abacus_type_4 (old).png": "1daf",
	"./abacus_type_4.png": "f69b",
	"./abacus_type_5 (old).png": "fd20",
	"./abacus_type_5.png": "ad32",
	"./abacus_type_6 (old).png": "ee3d",
	"./abacus_type_6.png": "2092",
	"./abacus_type_7 (old).png": "9c03",
	"./abacus_type_7.png": "0300",
	"./abacus_type_demo_1.png": "b4e9",
	"./abacus_type_demo_2.png": "a25c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7af9";